// import React from 'react';
// import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ScrollMagic from 'scrollmagic';
import * as d3 from "d3";
// import Waypoint from 'waypoints';

// require('waypoints/lib/noframework.waypoints.js');

// import * as d3annotation from 'd3-svg-annotation'


// import { map1 } from "map1";
// import {hello} from 'module'; // or './module'
// let val = hello(); // val is "Hello";




// console.log(document.getElementById('texty').clientHeight);
//ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();


var map1Cont = new ScrollMagic.Controller();


var map2Scene = new ScrollMagic.Scene({

			triggerElement: "#map2Trigger",
			duration: 1500}).addTo(map1Cont)
	.setClassToggle("#usa", "fade")
		.on("start", function () {
				animated()});;	



var map1Scene = new ScrollMagic.Scene({
	triggerElement: "#map1Trigger",	
	duration: 1200
	}).addTo(map1Cont)
// 
		.on("start", function () {
				executeMap()});	



		



		var barScene = new ScrollMagic.Scene({

			triggerElement: "#barTrigger",
			duration: 900}).addTo(map1Cont)
	// .setClassToggle("#bars", "fade")
		.on("start", function () {
				bars()});;
				


// var executeWaypoint = new Waypoint({
//   element: document.getElementById('#usMapTrigger'),
//   handler: executeMap()
// });




// var map2Cont = new ScrollMagic.Controller();


// var usScene = new ScrollMagic.Scene({
// 	triggerElement:"#usMapTrigger",
// 	duration: 100
// 	}).addTo(map2Cont)
// 	.on("enter leave", function (e){
// 		if (e.type=="enter") {
// 			console.log("ECECUTING US");
// 			executeUS()}

// 	});

// executeUS();

var controller = new ScrollMagic.Controller();

// var scene = new ScrollMagic.Scene({triggerElement: "#trigg1", duration: (document.getElementById('texty').clientHeight)*2.5, triggerHook: 1})
// 						.setPin("#stick", {pushFollowers: false})
// //.setClassToggle("#stick", "active")
// 						.addTo(controller)
// .addIndicators({name: "1 (duration: 3300)"}); // add indicators (requires plugin)


// var scene2 = new ScrollMagic.Scene({triggerElement: "#trigg2", duration: "100%", triggerHook: 1})
// 					.setClassToggle("#svg1", "slide") // add class toggle
// 					.setPin(".two", {pushFollowers: false})
// 					.addTo(controller);
// 					// .reverse(false);


// var scene22 = new ScrollMagic.Scene({triggerElement: "#trigg2", duration: "100%", triggerHook: 1})
// 					.setClassToggle("#contText", "textEndOpac")
// 					.addTo(controller);


var scene1 = new ScrollMagic.Scene({triggerElement: "#barTrigger", duration:1000, triggerHook:'onLeave', offset:0 })
						.setPin("#bars", {pushFollowers: false})
						.addTo(controller)


var scene2 = new ScrollMagic.Scene({triggerElement: "#scatter2Trigger", duration:1100, triggerHook:'onLeave', offset:0 })
						.setPin("#scatter2", {pushFollowers: false})
						.addTo(controller)


var scene3 = new ScrollMagic.Scene({triggerElement: "#map2Trigger", duration:1000, triggerHook:'onLeave', offset:0 })
						.setPin("#usa", {pushFollowers: false})
						.addTo(controller)


var scene4 = new ScrollMagic.Scene({triggerElement: "#map1Trigger", duration:1400, triggerHook:'onLeave', offset:0 })
						.setPin("#map1", {pushFollowers: false})
						.setClassToggle("#map1", "fade")
						.addTo(controller)



// var scene42 = new ScrollMagic.Scene({triggerElement: "#map1ExitTrigger", duration:0, triggerHook:'onEnter', offset:0 })
// 						// .setPin("#map1", {pushFollowers: false})
// 						.setClassToggle("map1", "opaque" )
// 						.addTo(controller)


var scene5 = new ScrollMagic.Scene({triggerElement: "#scatter1Trigger", duration:1000, triggerHook:'onLeave', offset:0 })
						.setPin("#scatter1", {pushFollowers: false})
						.addTo(controller)


var scene6 = new ScrollMagic.Scene({triggerElement: "#grid1Trigger", duration:1100, triggerHook:'onCenter', offset:200 })
						.setPin("#grid1", {pushFollowers: false})

						.setClassToggle("#high", "highlight")
						.addTo(controller)



var scene61 = new ScrollMagic.Scene({triggerElement: "#grid1Trigger", duration:0, triggerHook:'onEnter', offset:0 })

						.setClassToggle("#map1", "opaque1")
						.addTo(controller)





var scene66 = new ScrollMagic.Scene({triggerElement: "#grid2Trigger", duration:0, triggerHook:'onEnter', offset:200 })
						// .setPin("#grid2", {pushFollowers: false})
						.setClassToggle("#high", "highlight")
						.addTo(controller)



var scene7 = new ScrollMagic.Scene({triggerElement: "#javzaTrigger", duration:1500, triggerHook:'onLeave', offset:0 })
						.setPin("#javza", {pushFollowers: false})
						// .setClassToggle("#high", "highlight")
						.addTo(controller)




var sceneDoha = new ScrollMagic.Scene({triggerElement: "#grid3Trigger", duration:0, triggerHook:'onEnter', offset:200 })
						// .setPin("#grid2", {pushFollowers: false})
						.setClassToggle("#high", "highlight")
						.addTo(controller)



var scenedohaImg = new ScrollMagic.Scene({triggerElement: "#grid3Trigger", duration:1300, triggerHook:'onLeave', offset:200 })
						.setPin("#dohaDiv", {pushFollowers: false})
						// .setClassToggle("#high", "highlight")
						.addTo(controller)





var scatterScene = new ScrollMagic.Scene({

			triggerElement: "#scatter1Trigger",
			duration: 900}).addTo(controller)
			.on("start", function () {
				scatter1ex()

			})




// var scene71 = new ScrollMagic.Scene({triggerElement: "#text1Trigger", duration:1000, triggerHook:'onEnter', offset:0 })
// 						.setPin("#skinnyContainer", {pushFollowers: false})
// 						// .setClassToggle("#high", "highlight")
// 						.addTo(controller)

// .addIndicators({name: "1 (duration: 3300)"}); // add indicators (requires plugin)









const width= window.innerWidth;
const height= window.innerHeight;


	const svg = d3.select("#map1")
				.append('svg')
				.style("background","#303030")
				.attr("height", height)
				.attr("width", width)
			
			
				


	var g = svg.append('g');


// const but = document.querySelector("#butt");

// but.addEventListener("click", zm);





function executeMap() {d3.json("./world4.geojson", function (data) {


	let projection = d3.geoConicEqualArea()
   .scale(500)
    .rotate([160, 0])
    .center([-50, 47])
    .parallels([55, 65])
    .clipExtent([[-1, -1], [width + 1, height + 1]]);



 var geoPath = d3.geoPath()
    .projection( projection );




	g.selectAll('path')
		.data(data.features)
		.enter()
		.append("path")
		.attr("fill", "none")
		.transition()
		// .delay(1000)
		.duration(1000)
	.attr("fill", "#444444")
		.attr("stroke", "darkgray")
		.attr("stroke-width", 0)
		.attr("d", geoPath)
		   // .transition()
     //  .delay(5400)
     //  .attr("transform", "translate(40,240)scale(1.2)");






d3.json("data/locationsValue.json", function(d) {


const groupData = [d, anc];

const anc = [-149.9, 61.216667];


g.selectAll('circle')
		.data(anc)
		.enter()
		.append('circle')
		.attr("stroke", "darkgray")
		.attr("fill", "none")
		.attr("r", 3)
		.attr("cx", ()=> projection(anc)[0])
		.attr("cy", ()=> projection(anc)[1]);
		



g.selectAll('circle')
	.data(d)
		.enter()

	.append('circle')
			.attr("stroke", "darkgray")

		.attr("fill", "none")
		.attr("stroke-width", '1')
	.attr("r", 3)
		.attr("cx", (d)=> projection([d.lon, d.lat])[0])
		.attr("cy", (d)=> projection([d.lon, d.lat])[1])
		.attr("opacity", .9)


	// g.append("text")
	// 	.attr("x", 290)
	// 	.attr("y", 400)
	// 	.attr("class", "mapText")
	// 	.text("From 2014 to 2017, shipments to Alaska arrived from 23 countries")
	// 	.style("opacity", 0)
	// 	.transition()
	// 	.delay(2500)
	// 	.duration(1100)
	// 	.style("opacity", 1)



const startLine= g.selectAll('line')
		.data(d, d=>d.X);

	const finishLine = 	
		startLine.enter()
		.append("line")

	.attr("x2", (d)=> projection([d.lon, d.lat])[0])
	.attr("y2", (d)=>projection([d.lon, d.lat])[1])
	.attr("x1",(d)=> projection([d.lon, d.lat])[0])
	.attr("y1", (d)=>projection([d.lon, d.lat])[1])
	.attr("stroke-width", 3)
	.attr("opacity", .5)
	.attr("stroke-linecap","round")
	// .attr("stroke", 'lightblue');


  
  finishLine.merge(startLine)
    .transition()
   .duration(1906)
   // .delay(1000)
    .delay((d, i) => i * 30)
   .attr("x2", (d)=> projection([d.anclon, d.anclat])[0])
	.attr("y2", (d)=> projection([d.anclon, d.anclat])[1])
	.attr("x1",(d)=> projection([d.lon, d.lat])[0])
	.attr("y1", (d)=>projection([d.lon, d.lat])[1])
   	.attr("stroke", "#7fcdbb")
   	.attr("stroke-width", .2)
    .transition()
   .duration(1906)
   .delay(430)
   	.attr("stroke-width", d=> d.totals/40)
   	  //  .transition()
      // .delay(1500)
      // .attr("transform", "translate(540,240)scale(12)");

   






	})

})}




//****SCATTER 1****//
const margin ={top: 20, right: 20, bottom: 60, left: 90};
const scatterWidth = 1060 - margin.left - margin.right;
const scatterHeight = 600 - margin.top - margin.bottom;
const x= d3.scaleLinear()
	.range([0, scatterWidth]);
const y= d3.scaleLinear()
	.range([scatterHeight, 0]);

var xAxis = d3.axisBottom().scale(x);

var yAxis = d3.axisLeft().scale(y);

var svgScatter = d3.select('#scatter1')
	.append('svg')
	.attr("width", scatterWidth+margin.left+margin.right)
	.attr("height", scatterHeight+margin.top+margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");




function scatter1ex () {
d3.csv("data/portsCoded.csv", function(data1){

  x.domain(d3.extent(data1, function(d) { return d.foreignPorts; }));
  // y.domain(d3.extent(data1, function(d) { return d.shipmentCount; }));
y.domain([0, 4000000])
x.domain([0, 600])


svgScatter.append("g")
      .attr("transform", "translate(0," + scatterHeight + ")")
      // .attr("x", 500)
      // .attr("y", 0)
        .call(xAxis)
        .style("font-family", "Fira Mono");


  svgScatter.append("g")
     .call(yAxis)
    // .append("text")
	.attr("transform", "translate(10,0)")
      .attr("y", 6)
      .attr("dy", ".71em")
      	.style("font-family", "Fira Mono")


      	svgScatter.append("text")             
      .attr("transform",
            "translate(" + (scatterWidth/2-210) + " ," + 
                           (scatterHeight + 55) + ")")
      // .style("text-anchor", "middle")
      .text("Number of Foreign Port Connections")
              .style("font-family", "Fira Mono");
;

		svgScatter.append("text")             
         .attr("transform", "translate(" + -70 + "," + 350 + ")"+"rotate(270)")

    
      .text("Number of Shipments")
         .style("font-family", "Fira Mono");
      // .text("bleh");


var scatLabX = 800;
var scatLabY = 460;



		svgScatter.append("text") 
		.attr("x", scatLabX+10 )            
		.attr("y", scatLabY) 
		.text("West Coast Ports")
		.style("font-family", "Fira Mono")
		.style("font-size", 12)


svgScatter.append('circle')
.attr("cx", x(500))
.attr("cy", y(500000))
.attr("r", 9)
.attr("fill",	"#b2df8a" 
 )




		svgScatter.append("text") 
		.attr("x", 70 )            
		.attr("y", 230) 
		.text("Ports by Foreign Links and Shipments")
		.style("font-family", "Fira Mono")
		.style("font-size", 25)
		.style("font-weight", 700)
		// .style("background-color", "green")





		svgScatter.append("text") 
		.attr("x", scatLabX+10 )            
		.attr("y", scatLabY+20) 
		.text("East Coast Ports")
		.style("font-family", "Fira Mono")
		.style("font-size", 12)


svgScatter.append('circle')
.attr("cx", x(500))
.attr("cy", y(340000))
.attr("r", 9)
.attr("fill",	"#1f78b4" 
 )





		svgScatter.append("text") 
		.attr("x", scatLabX+10 )            
		.attr("y", scatLabY+40) 
		.text("Other Ports")
		.style("font-family", "Fira Mono")
		.style("font-size", 12)


svgScatter.append('circle')
.attr("cx", x(500))
.attr("cy", y(190000))
.attr("r", 9)
.attr("fill",	"orange" )


	// "#b2df8a" 
	// "#1f78b4"
	// "#1b9e77"




var dots = svgScatter.selectAll(".dot")
	.data(data1)
	.enter()
	.append("circle")
	.attr("class", "dot")
		.attr("r",44 )
	.attr("cx", 0)
	.attr("cy", -1000)
	.attr("opacity", 0)
	.transition()
	.delay((d,i)=> i*10)

	.attr("cx", d=>x(d.foreignPorts))	
	.attr("cy", d=>y(d.shipmentCount))
	.duration(1200)
	// .delay(300)
	.attr("opacity", .7)
	.attr("r",5 )
	.attr("fill", function(d) {if (d.Area == 1) {return "#b2df8a" } else if (d.Area ==2){return "#1f78b4"} else {return "orange"}});

svgScatter.selectAll("text")
	.data(data1)
	.enter()
	.append('text')
	.filter(d=> d.shipmentCount >199854)
	.attr("x", d=>x(d.foreignPorts)-120)
	.attr("y",	d=>y(d.shipmentCount)+20)
	.text(function(d){return d.port_of_unlading} )
	.style("font-size", '9')
	.style("font-family", "Fira Mono")




// const type = d3.annotationLabel

// const annotations = [{
//   note: {
//     label: "Longer text to show text wrapping",
//     title: "Annotations :)"
//   },
//   //can use x, y directly instead of data
//   data: { date: "18-Sep-09", close: 185.02 },
//   dy: 137,
//   dx: 162
// }]

// const parseTime = d3.timeParse("%d-%b-%y")
// const timeFormat = d3.timeFormat("%d-%b-%y")

// //Skipping setting domains for sake of example
// const x = d3.scaleTime().range([0, 800])
// const y = d3.scaleLinear().range([300, 0])

// const makeAnnotations = d3.annotation()
//   .editMode(true)
//   .type(type)
//   //accessors & accessorsInverse not needed
//   //if using x, y in annotations JSON
//   .accessors({
//     x: d => x(parseTime(d.date)),
//     y: d => y(d.close)
//   })
//   .accessorsInverse({
//      date: d => timeFormat(x.invert(d.x)),
//      close: d => y.invert(d.y)
//   })
//   .annotations(annotations)

// d3.select("svg")
//   .append("g")
//   .attr("class", "annotation-group")
//   .call(makeAnnotations)

})


}
// SCATTER 2


var svgScatter2 = d3.select('#scatter2')
	.append('svg')
	.attr("width", scatterWidth+margin.left+margin.right)
	.attr("height", scatterHeight+margin.top+margin.bottom)
			.style("background","white")
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");




svgScatter2.append("text") 
		.attr("x", ((scatterWidth+margin.left+margin.right)/2)-190 )            
		.attr("y", 15) 
		.text("Container Ships")
		.style("font-family", "Fira Mono")
		.style("font-size", 25)
		.style("font-weight", 700)







d3.json("data/vesselGroup.json", function(data){
//console.log("FUCK THIS");
  x.domain(d3.extent(data, function(d) { return d.domesticPorts; })).nice();
  y.domain(d3.extent(data, function(d) { return d.foreignPorts; })).nice();

svgScatter2.append("g")
      .attr("transform", "translate(0," + scatterHeight + ")")

      // .attr("x", 500)
      // .attr("y", 0)
        .call(xAxis)
                .style("font-family", "Fira Mono");


  svgScatter2.append("g")
     .call(yAxis)
    // .append("text")
	.attr("transform", "translate(10,0)")
      .attr("y", 6)
      .attr("dy", ".71em")
              .style("font-family", "Fira Mono");



    	svgScatter2.append("text")             
         .attr("transform", "translate(" + -70 + "," + 350 + ")"+"rotate(270)")
      .text("Foreign Ports")
         .style("font-family", "Fira Mono")
         	.style("fill", "black")




svgScatter2.append("text")             
      .attr("transform",
            "translate(" + (scatterWidth/2-210) + " ," + 
                           (scatterHeight + 55) + ")")
      // .style("text-anchor", "middle")
      .text("Domestic Ports")
              .style("font-family", "Fira Mono")
	.style("fill", "black")



var tooltip1 = d3.select('#scatter2').append("div")
                  .attr("class", "tooltip")
                  .style("opacity", 0);

              // tooltip mouseover event handler
              var tipMouseover = function(d) {
                  // var color = colorScale(d.manufacturer);
                  var html1  = "Vessel Name: "+d.vessel_name + "<br/>" +
                              "Shipment Count: "+d.shipmentCount.toLocaleString();


                  // tooltip1.style("left", (d3.event.pageX + 15) + "px")
                  //     .style("top", (d3.event.pageY - 28) + "px")


					d3.select(this)
					.attr("fill", "black")
					.transition()
					.duration(200)
						.attr("r",function(d) {return Math.sqrt(d.shipmentCount/300) })


                  tooltip1.html(html1)
       //            .style("left", d3.select(this).attr("cx")+(margin.left+1200)+"px")     
  					// .style("top", d3.select(this).attr("cy") +margin.top+ "px")


 					.style("left", 210+"px")     
  					.style("top", 61+"px")


				// .attr("x", 550)     
  		// 		.attr("y", 15)





                    .transition()
                      .duration(100) // ms
                      .style("opacity", .9); // started as 0!

console.log("were in!!!");
console.log("the XXXXX"+d3.select(this).attr("cx"));

console.log("the WYYYYY"+d3.select(this).attr("cy"));
console.log(tooltip1);


              };
              // tooltip mouseout event handler
              var tipMouseout = function(d) {
                  tooltip1.transition()
                      .duration(300) // ms
                      .style("opacity", .6); 

                      d3.select(this).attr("fill", "#3690c0");

// don't care about position!


console.log("were out!!!")

              };











svgScatter2.selectAll(".dot")
	.data(data)
	.enter()
	.append("circle")
	.attr("class", "dot")
	.attr("r",function(d) {return Math.sqrt(d.shipmentCount/600) })
	.attr("cx", d=>x(d.domesticPorts))	
	.attr("cy", d=>y(d.foreignPorts))
	.attr("opacity", .4)
	.attr("fill", "#3690c0")
	.on("mouseover", tipMouseover)
    .on("mouseout", tipMouseout);



	// svgScatter2
	// .selectAll("text")
	// .data(data)
	// .enter()
	// .append('text')
	// 	.filter(d=> d.shipmentCount >89900)
	// .attr("x", d=>x(d.domesticPorts)-20)	
	// .attr("y", d=>y(d.foreignPorts)-20)
	// .text(function(d){return d.vessel_name} )
	// .style("font-size", '12')
	// .style("font-family", "Fira Mono")
	// .style("fill", "black")

})








// vesselsize

// const vs = d3.select("#vessel").append('svg')
// .attr("width", scatterWidth+margin.left+margin.right)
// 	.attr("height", scatterHeight+margin.top+margin.bottom)
// 	.append("g")
// 	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");



// 	d3.csv("data/top19_new.csv", function (d) {
// 		const exVesselLen = d3.extent(d, data=>data.length);
// 		const exVesselBre = d3.extent(d, data=>data.breadth);
// console.log('da bre extent'+exVesselBre);

// const xVessel= d3.scaleLinear()
// 	.domain(exVesselBre)
// 	.range([0, 200]);
// const yVessel= d3.scaleLinear()
// 	.domain(exVesselLen)
// 	.range([0, scatterHeight-100]);

// console.log(xVessel(d.length));
// console.log(xVessel(d.breadth));

// 	vs.selectAll("rect")
// 		.data(d)
// 		.enter()
// 		.append('rect')
// 		.attr("fill", "none")
// 		.attr("stroke", "red")
// 		.attr("stroke-width", .4)
// 		.attr("opacity", .5)
// 		.attr('height', each=> scatterHeight-yVessel(each.length))
// 		.attr('width', each=> xVessel(each.breadth))
// 			.attr("x", 0 )
// 		// .attr("fill", ()=>`rgba(${Math.random()*254},190,233,.49)`)
// 		.attr("y", 10);


// 		vs.selectAll('text')
// 			.data(d)
// 			.enter()
// 			.append('text')
// 			.attr("x", function (each, i){return i*180} )
// 			.text(each=>each.vessel_name);




// 	}) 


	const us = d3.select("#us")
				.append('svg')
				// .style("background","#303030")
				.attr("height", height)
				.attr("width", width);
				


	var usg = us.append('g');


// function executeUS() {




// // const but = document.querySelector("#butt");

// // but.addEventListener("click", zm);



// d3.json("./us_lakes.geojson", function (data) {


// 	let projection = d3.geoConicEqualArea()

//     .rotate([96, 0])
//     .center([-.6, 33.7])
//   .parallels([29.5, 45.5])
//     .scale(900)
// 	.translate([width / 2, height / 2])

//     .clipExtent([[-1, -1], [width + 1, height + 1]]);



//  var geoPath = d3.geoPath()
//     .projection( projection );


// 	usg.selectAll('path')
// 		.data(data.features)
// 		.enter()
// 		.append("path")
// 		.attr("fill", "#444444")
// 		//.attr("stroke", "darkgray")
// 		.attr("stroke-width", .5)

// 		.attr("d", geoPath);


// d3.csv("data/pport_16.csv", function (d) {

// // console.log(projection([-131, 45]));
// // console.log("a proj");


// usg.selectAll('circle')
// 	.data(d)
// 	.enter()
// 	.append('circle')
	

// 		.attr("fill", "whitesmoke")
// 		//.attr("stroke-width", '1')
// 		.attr("r", 100)
// 		.attr("opacity", 0)
// 		.attr("cx", (d,i)=>44*i*Math.random())
// 		.attr("cy", (d,i)=>44*i*Math.random())
// 		.transition()
// 		.ease(d3.easeSin)
// 			.attr("opacity", .5)
// 		.attr("r", 2)
// 		.attr("cx", (d)=> projection([d.LONGITUDE, d.LATITUDE])[0])
// 		.attr("cy", (d)=> projection([d.LONGITUDE, d.LATITUDE])[1])
// 			.duration(3000)
// 			.delay(100)
// 	.transition()
// 		.ease(d3.easeLinear)
// 			.attr("r", d=>d.FOREIGN/2500000)
// 			.delay(500)
// 			.duration(1000)
// 			.transition()
// 			.attr("fill", "green")
// 			.delay(500)
// 			.duration(1000)
// 				.transition()
// 			.attr("r", d=>d.DOMESTIC/1000000)

// 			.delay(500)
// 			.duration(1000);

// })

// })}

	




// ////#animated


const usa = d3.select("#usa")
				.append('svg')
			.style("background","white")
				.attr("height", height)
				.attr("width", width);
				


	var usag = usa.append('g');


usag.append("text") 
		.attr("x", 60 )            
		.attr("y", 110) 
		.text("Weekly Shipments")
		.style("font-family", "Fira Mono")
		.style("font-size", 25)
		.style("font-weight", 700)


let projection1 = d3.geoConicEqualArea()

    .rotate([96, 0])
    .center([-.6, 33.7])
  .parallels([29.5, 45.5])
    .scale(900)
	.translate([width / 2, height / 2])

    .clipExtent([[-1, -1], [width + 1, height + 1]]);




function animated () { 

d3.json("./us_lakes.geojson", function (data) {





 var geoPath = d3.geoPath()
    .projection( projection1 );


	usag.selectAll('path')
		.data(data.features)
		.enter()
		.append("path")
		.attr("fill", "#4d4d4d")
		// .attr("stroke", "whitesmoke")
		//.attr("stroke", "darkgray")
		// .attr("stroke-width", .7)
		.attr("d", geoPath);



const legX = 200;
const legY= 500;


		usag.append('circle')
		.attr("r", Math.sqrt(100000/35) )
		.attr("cx", legX)
		.attr("cy", legY)
		.attr("stroke", '#67a9cf')
		.attr("stroke-width", 1.1)
				.attr("fill", "none")



		usag.append('circle')
		.attr("r", Math.sqrt(5000/35) )
		.attr("cx", legX)
		.attr("cy", legY+41)
			.attr("stroke-width", 1.1)
		.attr("stroke", '#67a9cf')
		.attr("fill", "none")



		usag.append('text')
		.text("100,000 shipments")
		.attr("x", legX+50)
		.attr("y", legY+40)
		.attr("style", "font-size:11")

	usag.append('text')
		.text("5,000 shipments")
		.attr("x", legX+56)
		.attr("y", legY+50)
				.attr("style", "font-size:11")


	

// .attr("cx", ()=> projection1([-80, 26][0]))
// 		.attr("cy", ()=>  projection1([-80, 26][1]))

d3.csv("data/usa50week.csv", function (data) {

var byDate = d3.nest()
	.key(d=>d.week)
	.map(data)


var ent = d3.nest()
	.key(d=>d.week)
	.entries(data)

// console.log("ent");

// console.log(ent)

// console.log("byDate");
// console.log(byDate)

//bydate is the MAP
//ent is the ?? 




// console.log('ent');
// console.log(ent);
// //console.log(data);

// console.log(typeof(ent));
// console.table(ent)

// console.log("accesing values");
// console.log(ent[4].values[4].lon)


// // byDate.each(function (dat){

// console.log("THE DEE");
// console.log(d);

// dat.forEach(function (d,index, array){    
	// console.log("INSIDE THE SEDCON");
	//  console.log(array);
// console.log(d);

// usag.selectAll('text')
// 	.data(ent)
// 	.enter()
// 	.append('text')
// 	.attr("x", 123)
// 	.attr("y", 233)
// 	.attr("fill", "black")
// 	.text((d)=> JSON.stringify(d))
//console.log(d[r]);

//console.log(i);
var usageGroup = usag.selectAll('g')
	.data(ent, ent=> ent.key)
	.enter()
	.append('g')
	.attr('opacity', 0)
	
// var color = d3.scaleCategory20b();

	usageGroup.transition()
	.duration(600)
	.delay((d,i)=> i*500)
	.attr('opacity', .8)	
	.transition()
	// .remove()
	.attr('opacity', 0)
	// .attr("scale", .2)
	// .duration(300)
	// .delay((d,i)=> i*500)
	



	usageGroup.selectAll('text')
		.data(d1=> d1.values)
		.enter()
		.append('text')
		.attr("x", 100)
		.attr("y", 400)
		.text((d9, i)=> "2017 Week: "+d9.week)
		.attr("fill", "black")
		.style("font-size",40 )
		.style("font-family", "Fira Mono")


	usageGroup.selectAll('circle')
		.data(d1 => d1.values)
		.enter()
		.append('circle')
	// // .attr("opacity", 0)
 // 	.transition()
 //     .duration(250)
	// .delay((d,i)=>i*20)
	.attr("r", (d2)=>Math.sqrt(d2.count/35) )
		.attr("cx", (d2, i)=> projection1([d2.lon, d2.lat])[0])
		.attr("cy", (d2, i)=> projection1([d2.lon, d2.lat])[1])
		.attr("stroke-width", 1.1)
		.attr("stroke", '#67a9cf')
		// .attr("filter", "blur(300px)")
		// .attr("fill", function(d2, i){ return "rgb("+Math.floor(255-i*Math.random())+10+","+Math.floor(255-i*Math.random())+","+Math.floor(Math.random()*255-i)+")"})
		// .attr("fill", function(d2, i){ return "rgb("+Math.floor(255*Math.random()-d2.lon)+","+Math.floor(255*Math.random()-d2.lon)+","+Math.floor(Math.random()*255-d2.lon)+")"})
		// .attr("opacity", .1)

		.transition()
		.delay(100)
	// .attr("stroke", 'red')

		.attr("fill", "none" )
	// .attr("fill", "colorr")





// 	.transition()
//      .duration(250)
// 	.delay((d,i)=>i*20)
// 		.attr("stroke-width", 0);
// //console.log(ent[4].values[4].lon)

// })


			// .attr("opacity", 0)
		
// usag.selectAll('circle').remove()

	



// setTimeout(usagMap, 50)
})


// usag.selectAll('circle')
// 	.data(byDate.each(function (d,i){

// 	usag.enter()
// 	.append('circle')
// 	.attr("opacity", .1)
// 	.attr("fill", "goldenrod")
// 		//.attr("stroke-width", '1')
// 		// .transition()
// 		// .duration(2000)
// 		// .delay((d,i)=>i*20)
// 		.attr("r", d=>d.count/1000)
// 		.attr("cx", (d)=> projection1([d.lon, d.lat])[0])
// 		.attr("cy", (d)=> projection1([d.lon, d.lat])[1])
// 		.attr("opacity", .4)

// 	})
	

	// })

	




		//.duration(1000)
	// .transition()
	// 	.ease(d3.easeLinear)
	// 		.attr("r", d=>d.FOREIGN/2500000)
	
	// 			.transition()
	// 		.attr("r", d=>d.DOMESTIC/1000000)

	// 		.delay(500)
	// 		.duration(1000);

})
    }
// animated();
	


// var expensesByName = d3.nest()
//   .key(function(d) { return d.name; })
//   .entries(expenses);


const barHeight= 120;
// const barHeight= window.innerHeight/5;



	const bar1 = d3.select("#bar1")
				.append('svg')
				.style("background","white")
				.attr("height", barHeight)
				.attr("width", width);
				

	const bar1g = bar1.append('g');		


	const bar2 = d3.select("#bar2")
				.append('svg')
				.style("background","white")
				.attr("height",barHeight)
				.attr("width", width);
				

	const bar2g = bar2.append('g');		

	const bar3 = d3.select("#bar3")
				.append('svg')
				.style("background","white")
				.attr("height", barHeight)
				.attr("width", width);
				

	const bar3g = bar3.append('g');		

		const bar4 = d3.select("#bar4")
				.append('svg')
				.style("background","white")
				.attr("height", barHeight)
				.attr("width", width);
				

	const bar4g = bar4.append('g');		


		const bar5 = d3.select("#bar5")
				.append('svg')
				.style("background","white")
				.attr("height", barHeight)
				.attr("width", width);
				

	const bar5g = bar5.append('g');		


	// const bar6 = d3.select("#bar6")
	// 			.append('svg')
	// 			.style("background","white")
	// 			.attr("height", barHeight)
	// 			.attr("width", width);
				

	// const bar6g = bar6.append('g');		


	// const bar7 = d3.select("#bar7")
	// 			.append('svg')
	// 			.style("background","red")
	// 			.attr("height", barHeight)
	// 			.attr("width", width);
				

	// const bar7g = bar7.append('g');		


function bars () {







d3.json("data/groupLA.json", function(data){




		// data.forEach(function(d,i){
		// 	var parseTime = d3.timeParse("%Y-%m-%d")
		// 	d.date=  parseTime(d.subDate);

		// 		// console.log(d.date);
		// })
		const extLA =  d3.extent(data, function(d) { return d.count; });
		console.log("interal EXT");
		//console.log(exLa);
		// return d3.extent(data, d => d.count);
	
const bar = function( loc,div, city, col) {

d3.json("data/"+loc+".json", function(locdata){



		locdata.forEach(function(d,i){
			var parseTime = d3.timeParse("%Y-%m-%d")
			d.date=  parseTime(d.subDate);

				// console.log(d.date);
		})






// data.forEach(function(d,i) {
// d.date = format(d.date);
// });


		const extX =d3.extent(locdata, d =>  d.date);
		const extY =d3.extent(locdata, d =>  d.count);

		const xbar=d3.scaleTime()
			// .domain(extX)
    .domain([new Date(2017, 0, 1), new Date(2017, 11, 20)])



			.range([0, width-150]);

		const ybar = d3.scaleLinear()
				.domain(extLA)
				.range([barHeight, 0])
console.log("the xbar");
				console.log(extX);


var xAxisbar = d3.axisBottom().scale(xbar).ticks(22, d3.timeFormat("%B"));

var yAxisbar = d3.axisLeft().scale(ybar).ticks(6)


	div.append('g')
	.call(xAxisbar)
		.attr("transform","translate(100,100)")
      	.style("font-family", "Fira Mono")


	div.append('g')
	.call(yAxisbar)
			.attr("transform","translate(75,-20)")

      // .attr("y", -56)
      // .attr("x",200)
      // .attr("dy", ".2em")
      	.style("font-family", "Fira Mono")
      	.attr("barStyle")
		// console.log(x(data.date))
		// console.log(y(data[1].count))
		// console.log(x(data[1].date))


		div.selectAll("rect")
		.data(locdata)
		.enter()
		.append("rect")
		// .attr("fill", ()=> `rgb(${Math.round(Math.random()*215)}, ${Math.round(Math.random()*215)},222)`)
		.attr("fill", col)
		.attr("width", 5)
		.attr("x", (d,i) => i-1014)
		.attr("y", (d,i) => i-1000)
		.attr("stroke-width", .1)
		// .attr("stroke", "darkgray")
		.transition()
		.ease(d3.easeCircle)
		.delay((d, i)=> Math.random()*((365-i)+1)*5)
		// .delay((i)=> Math.random()*10)
		.duration(2000)
	.attr("width", 2)
.attr("height", d=> barHeight -ybar(d.count))
		.attr("x", d=> xbar(d.date)+100)
		.attr("y", d=> ybar(d.count)-20)
		.attr("rx", .1)




		div
		// .selectAll("text")
		// .data(locdata)
		// .enter()
		.append("text")
			.attr("x", 100)
			.attr("y", 20)
			.text(city)
			      	.style("font-family", "Fira Mono");




// var filter = div.append("defs")
 


//##CIRCLE VIS
	// div.selectAll('circle')
	// .data(locdata)
	// 	.enter()
	// 	.append('circle')
	// 	.attr("fill", "none")
	// 	.attr("stroke-width", .5)
	// 	.attr("stroke", "blue")
 // 		.attr("cx", (d,i) => i-554)
	// 	// .attr("cy", (d,i) => i+100)
	// 			.attr("r", d=>Math.sqrt(d.count/100) )

	// 	.transition()
	// 	.delay((d, i)=> Math.random()*((365-i)+1)*7)
	// 	// .delay((d, i)=> i*10)
	// 	.duration(4000)
	// 	// .delay((i)=> Math.random()*10)
	// .attr("cx", d=> x(d.date))
	// .attr('opacity', .3)
	// 	.attr("cy", 10)
	// 	.attr("r", d=>Math.sqrt(d.count/500) )
			})
			
		
			}

bar("groupLA", bar1g, "Los Angeles", "#253494");
bar("groupNYC", bar2g,"New York", "#2c7fb8");
bar("groupLB", bar3g ,"Long Beach", "#41b6c4");
bar("groupChar", bar4g, "Charlotte", "#a1dab4");
bar("groupSea", bar5g, "Seattle", "#756bb1");
// bar("groupMob", bar6g, "Mobile");
// bar("groupCle", bar7g, "Cleveland");




	})
	
}
//console.log(extLA);


	












// WEBPACK FOOTER //
// ./src/index.js